const STYLE_ID = 'dashboard-tutor-visual-parity-styles';
const DASHBOARD_APP_ID = 'dashboard';
const DASHBOARD_APP_SCOPE = 'dashboard';
const TUTOR_DESK_PACK_ID = 'tutor-desk';
const TUTOR_DESK_SAAS_FINAL_UI_STANDARD = 'ttoria-saas-final-ui-v1';

export const DASHBOARD_TUTOR_VISUAL_STYLES = `
html[data-kg-dashboard-visual="tutor-desk"] {
  color-scheme: dark;
  --kg-dashboard-shell-gap: clamp(8px, 0.84vw, 16px);
  --kg-dashboard-shell-inset: clamp(var(--ui-space-08), 0.84vw, var(--ui-space-16));
  --kg-dashboard-shell-nav-width: clamp(176px, 12vw, 224px);
  --kg-dashboard-surface: var(--ui-card-bg-solid);
  --kg-dashboard-surface-soft: color-mix(in srgb, var(--ui-card-bg-solid) 88%, Canvas);
  --kg-dashboard-surface-strong: color-mix(in srgb, var(--ui-card-bg-solid) 94%, CanvasText);
  --kg-dashboard-border: var(--ui-card-border);
  --kg-dashboard-text: var(--ui-text-main);
  --kg-dashboard-muted: var(--ui-text-subtle);
  --kg-dashboard-faint: var(--ui-text-muted);
  --kg-dashboard-shadow: var(--ui-card-shadow);
  --kg-dashboard-control-bg: var(--ui-input-bg);
  --kg-dashboard-control-border: var(--ui-input-border);
  --kg-dashboard-control-text: var(--ui-input-text);
  --kg-dashboard-panel-radius: min(var(--ui-card-radius), 18px);
  --kg-dashboard-control-radius: min(var(--ui-control-radius), 14px);
}

html[data-kg-dashboard-visual="tutor-desk"],
html[data-kg-dashboard-visual="tutor-desk"] body {
  min-height: 100%;
  background:
    radial-gradient(circle at 18% 4%, var(--ui-card-glow-a), transparent 34rem),
    radial-gradient(circle at 84% 10%, var(--ui-card-glow-b), transparent 28rem),
    linear-gradient(180deg, var(--kg-dashboard-surface-strong), Canvas);
  color: var(--kg-dashboard-text);
  font-family: var(--ui-font-family-base);
}

html[data-kg-dashboard-visual="tutor-desk"] #platformShellMount {
  min-height: 100%;
  background: transparent;
}

html[data-kg-dashboard-visual="tutor-desk"] .ds-shell-layout.platform-shell-layout {
  grid-template-columns: var(--kg-dashboard-shell-nav-width) minmax(0, 1fr) !important;
  gap: var(--kg-dashboard-shell-gap) !important;
  padding: var(--kg-dashboard-shell-inset) !important;
  background: transparent !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .ds-shell-layout.platform-shell-layout > .ds-shell-layout__nav,
html[data-kg-dashboard-visual="tutor-desk"] .ds-shell-layout.platform-shell-layout > .ds-shell-layout__main {
  min-width: 0;
  border: 1px solid var(--kg-dashboard-border) !important;
  border-radius: var(--kg-dashboard-panel-radius) !important;
  box-shadow: var(--kg-dashboard-shadow) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .ds-shell-layout.platform-shell-layout > .ds-shell-layout__nav {
  padding: clamp(var(--ui-space-08), 0.7vw, var(--ui-space-12)) !important;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--ui-card-bg-solid) 90%, CanvasText), var(--kg-dashboard-surface-strong)),
    linear-gradient(135deg, var(--ui-card-glow-a), var(--ui-card-glow-b)) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .ds-shell-layout.platform-shell-layout > .ds-shell-layout__main {
  padding: clamp(var(--ui-space-08), 0.7vw, var(--ui-space-12)) !important;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--kg-dashboard-surface-soft) 94%, transparent), var(--kg-dashboard-surface)) !important;
  overflow: hidden;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__app-name {
  display: block;
  width: 100%;
  margin: 0;
  color: var(--kg-dashboard-text) !important;
  font-size: clamp(1.28rem, 1.18rem + 0.24vw, 1.48rem);
  font-weight: var(--ui-font-weight-bold);
  letter-spacing: 0;
  line-height: 1;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  text-shadow: 0 0 18px var(--ui-card-glow-a);
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__app-name::after {
  content: "";
  display: block;
  height: 2px;
  width: 100%;
  margin-top: 10px;
  border-radius: var(--ui-pill-radius);
  background:
    linear-gradient(90deg, transparent, var(--ui-brand-logo-start), var(--ui-brand-logo-mid), transparent);
  opacity: 0.9;
  pointer-events: none;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__app-build-info {
  display: none !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav-items {
  gap: 8px;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-nav__button,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-logout__button {
  min-height: 42px;
  border-radius: var(--kg-dashboard-control-radius) !important;
  border-width: 1px !important;
  color: var(--ui-sidebar-inactive-text) !important;
  box-shadow: var(--ui-btn-secondary-shadow) !important;
  transition: transform 140ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease, color 180ms ease;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-nav__button:not(.platform-shell-nav__button--active),
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-logout__button {
  background: var(--ui-sidebar-inactive-bg) !important;
  border-color: var(--ui-sidebar-inactive-border) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-nav__button:not(.platform-shell-nav__button--active):hover,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-nav__button:not(.platform-shell-nav__button--active):focus-visible,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-logout__button:hover,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-logout__button:focus-visible {
  border-color: var(--ui-card-interactive-border-hover) !important;
  box-shadow: var(--ui-btn-secondary-shadow-hover) !important;
  transform: translateY(-1px);
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-nav__button.platform-shell-nav__button--active {
  background: linear-gradient(135deg, var(--ui-sidebar-active-start), var(--ui-sidebar-active-end)) !important;
  border-color: var(--ui-sidebar-active-border) !important;
  color: var(--ui-sidebar-active-text) !important;
  box-shadow: var(--ui-btn-primary-shadow) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-nav__button *,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav .platform-shell-logout__button * {
  color: inherit !important;
  opacity: 1 !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__status-shell,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__status-shell .ds-shell-status,
html[data-kg-dashboard-visual="tutor-desk"] #platformStatus {
  width: 100%;
}

html[data-kg-dashboard-visual="tutor-desk"] #platformStatus,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__status-text {
  border: 1px solid var(--ui-notice-border) !important;
  border-radius: var(--ui-pill-radius) !important;
  background:
    linear-gradient(135deg, color-mix(in srgb, var(--ui-notice-bg) 82%, transparent), color-mix(in srgb, var(--ui-card-bg-solid) 92%, transparent)) !important;
  color: var(--ui-notice-text) !important;
  box-shadow: var(--ui-btn-secondary-shadow) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] #platformRoot,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-plugin-stage,
html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-plugin-host {
  min-width: 0;
  min-height: 0;
}

html[data-kg-dashboard-visual="tutor-desk"] #platformRoot {
  overflow: auto;
  scrollbar-gutter: stable;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-contacts-root,
  .kgc-emails-root,
  .kgc-companies-root,
  .kg-tasks-root,
  .kg-tasksboard-root,
  .dashboard-calendar-root,
  .kg-marketing-root,
  .kg-kpi-root,
  .kg-settings-root
) {
  width: 100%;
  min-width: 0;
  min-height: 0;
  color: var(--kg-dashboard-text) !important;
  background: transparent !important;
  font-family: var(--ui-font-family-base);
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-shell-panel,
  .kg-email-shell-panel,
  .kg-companies-shell-panel,
  .kg-tasks-shell-panel,
  .kg-kpi-shell-panel,
  .ds-plugin-page-panel,
  .ds-plugin-shell-frame,
  .kg-settings-shell-panel
) {
  width: 100%;
  min-width: 0;
  min-height: 0;
  border: 1px solid var(--kg-dashboard-border) !important;
  border-radius: var(--kg-dashboard-panel-radius) !important;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--kg-dashboard-surface-soft) 94%, transparent), var(--kg-dashboard-surface)) !important;
  box-shadow: var(--kg-dashboard-shadow) !important;
  color: var(--kg-dashboard-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-shell-panel,
  .kg-email-shell-panel,
  .kg-companies-shell-panel,
  .kg-tasks-shell-panel,
  .kg-kpi-shell-panel,
  .ds-plugin-page-panel,
  .ds-plugin-shell-frame,
  .kg-settings-shell-panel
) > .ds-panel__body {
  background: transparent !important;
  color: inherit !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-shell-body,
  .kg-email-shell-body,
  .kg-companies-shell-body,
  .kg-tasks-shell-body,
  .kg-kpi-shell-body,
  .ds-plugin-page-panel__content-region,
  .kg-settings-shell-body,
  .kg-settings-panel-body
) {
  min-width: 0;
  color: var(--kg-dashboard-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-shell-title,
  .kg-email-shell-title,
  .kg-companies-shell-title,
  .kg-tasks-shell-title,
  .kg-kpi-shell-title,
  .ds-plugin-page-panel__title,
  .kg-settings-title,
  h1,
  h2,
  h3
) {
  color: var(--kg-dashboard-text) !important;
  font-family: var(--ui-font-family-heading);
  letter-spacing: 0;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-shell-sub,
  .kg-email-shell-sub,
  .kg-companies-shell-sub,
  .kg-tasks-shell-sub,
  .kg-kpi-shell-sub,
  .ds-plugin-page-panel__subtitle,
  .kg-settings-subtitle,
  .muted
) {
  color: var(--kg-dashboard-muted) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  [data-ds-component="ds/card"],
  [data-ds-component="ds/sub-panel"],
  [data-ds-component="ds/alert"],
  [data-ds-component="ds/empty-state"],
  .ds-table-shell,
  .kgc-table-wrap,
  .kgc-table-region .ds-table-shell__body,
  .kg-email-table-region .ds-table-shell__body,
  .kg-companies-table-region .ds-table-shell__body,
  .kg-settings-table-panel,
  .kg-settings-box,
  .kg-kpi-drawer-shell
) {
  border-color: var(--kg-dashboard-border) !important;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--kg-dashboard-surface-soft) 92%, transparent), color-mix(in srgb, var(--kg-dashboard-surface) 96%, transparent)) !important;
  box-shadow: var(--kg-dashboard-shadow) !important;
  color: var(--kg-dashboard-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .ds-search-action-toolbar,
  .ds-filter-bar,
  .kgc-toolbar,
  .kg-email-toolbar,
  .kg-companies-toolbar,
  .kg-kpi-toolbar,
  .kg-settings-nav
) {
  border: 1px solid var(--kg-dashboard-border);
  border-radius: var(--kg-dashboard-panel-radius);
  background:
    linear-gradient(135deg, color-mix(in srgb, var(--kg-dashboard-surface-soft) 88%, transparent), color-mix(in srgb, var(--kg-dashboard-surface) 94%, transparent));
  box-shadow: var(--ui-btn-secondary-shadow);
  padding: clamp(var(--ui-space-08), 0.7vw, var(--ui-space-12));
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  [data-ds-component="ds/search"],
  [data-ds-component="ds/input"] .ds-input__control,
  [data-ds-component="ds/select"] .ds-select__control,
  [data-ds-component="ds/textarea"] .ds-textarea__control,
  [data-ds-component="ds/date-time-picker"],
  [data-ds-component="ds/multi-select"],
  input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),
  textarea,
  select
) {
  border-color: var(--kg-dashboard-control-border) !important;
  background: var(--kg-dashboard-control-bg) !important;
  box-shadow: var(--ui-btn-secondary-shadow) !important;
  color: var(--kg-dashboard-control-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  [data-ds-component="ds/search"] .ds-search__input,
  [data-ds-component="ds/input"] .ds-input__value,
  [data-ds-component="ds/select"] .ds-select__native,
  [data-ds-component="ds/textarea"] .ds-textarea__native,
  [data-ds-component="ds/date-time-picker"] .ds-date-time-picker__input
) {
  background: transparent !important;
  color: var(--kg-dashboard-control-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  [data-ds-component="ds/search"]:focus-within,
  [data-ds-component="ds/input"]:focus-within .ds-input__control,
  [data-ds-component="ds/select"]:focus-within .ds-select__control,
  [data-ds-component="ds/textarea"]:focus-within .ds-textarea__control,
  button:focus-visible,
  [role="button"]:focus-visible,
  a[href]:focus-visible
) {
  outline: 2px solid var(--ui-card-interactive-border-hover) !important;
  outline-offset: 2px;
  box-shadow: var(--ui-card-interactive-shadow-hover) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] [data-ds-component="ds/button"] {
  border-radius: var(--ui-btn-radius) !important;
  font-size: var(--ui-font-size-btn);
  font-weight: var(--ui-font-weight-bold);
  letter-spacing: 0;
}

html[data-kg-dashboard-visual="tutor-desk"] [data-ds-component="ds/button"].ds-button--intent-primary {
  background: linear-gradient(135deg, var(--ui-btn-primary-start), var(--ui-btn-primary-mid), var(--ui-btn-primary-end)) !important;
  border-color: var(--ui-sidebar-active-border) !important;
  box-shadow: var(--ui-btn-primary-shadow) !important;
  color: var(--ui-btn-primary-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] [data-ds-component="ds/button"].ds-button--intent-secondary {
  background: linear-gradient(135deg, var(--ui-btn-secondary-start), var(--ui-btn-secondary-mid), var(--ui-btn-secondary-end)) !important;
  border-color: var(--ui-btn-secondary-border) !important;
  box-shadow: var(--ui-btn-secondary-shadow) !important;
  color: var(--ui-btn-secondary-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] [data-ds-component="ds/button"].ds-button--intent-danger {
  background: linear-gradient(135deg, var(--ui-btn-danger-start), var(--ui-btn-danger-mid), var(--ui-btn-danger-end)) !important;
  box-shadow: var(--ui-btn-danger-shadow) !important;
  color: var(--ui-btn-danger-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] [data-ds-component="ds/button"] .ds-button__label,
html[data-kg-dashboard-visual="tutor-desk"] [data-ds-component="ds/button"] .ds-button__icon {
  color: inherit !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .ds-table-shell__body,
  .kgc-table-wrap,
  .kg-email-table-wrap,
  .kg-companies-table-wrap,
  .kg-settings-table-wrap
) {
  scrollbar-gutter: stable;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-table__cell--header,
  .kg-email-table__cell--header,
  .kg-companies-table__cell--header,
  .kg-settings-table__cell--header,
  .kg-kpi-summary-table__cell--header,
  .ds-table-advanced__cell--header
) {
  background: var(--ui-table-head-bg) !important;
  color: var(--ui-table-head-text) !important;
  border-color: var(--ui-table-border) !important;
  font-size: var(--ui-table-head-font-size);
  letter-spacing: var(--ui-table-head-letter-spacing);
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-table__cell,
  .kg-email-table__cell,
  .kg-companies-table__cell,
  .kg-settings-table__cell,
  .kg-kpi-summary-table__cell,
  .ds-table-advanced__cell
) {
  color: var(--ui-table-cell-text) !important;
  border-color: var(--ui-table-row-border) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-table__row--base,
  .kg-email-table__row--base,
  .kg-companies-table__row--base,
  .kg-settings-table__row--base
) > * {
  background: var(--ui-table-row-even) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .kgc-table__row--alt,
  .kg-email-table__row--alt,
  .kg-companies-table__row--alt,
  .kg-settings-table__row--alt
) > * {
  background: var(--ui-table-row-odd) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  [data-ds-component="ds/badge"],
  .kgc-stage-pill,
  .kg-email-stage-pill,
  .kg-companies-stage-pill,
  .kg-settings-users-count-pill
) {
  border-color: var(--ui-pill-border) !important;
  background: var(--ui-pill-bg) !important;
  color: var(--ui-pill-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .ds-modal,
  .modal-card,
  .modal-shell,
  .kgc-modal-card,
  .kg-email-modal-card,
  .kg-companies-modal-card,
  .kg-tasks-modal-card,
  .kg-settings-modal-frame-host > *
) {
  border: 1px solid var(--kg-dashboard-border) !important;
  border-radius: var(--kg-dashboard-panel-radius) !important;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--kg-dashboard-surface-soft) 94%, transparent), var(--kg-dashboard-surface)) !important;
  box-shadow: var(--kg-dashboard-shadow) !important;
  color: var(--kg-dashboard-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .ds-empty-state__label,
  .ds-alert__label,
  .ds-card__title,
  .ds-sub-panel__title
) {
  color: var(--kg-dashboard-text) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] :is(
  .ds-empty-state__body,
  .ds-alert__body,
  .ds-card__body,
  .ds-sub-panel__body
) {
  color: var(--kg-dashboard-muted) !important;
}

html[data-kg-dashboard-visual="tutor-desk"] .platform-auth-login,
html[data-kg-dashboard-visual="tutor-desk"] .platform-auth-login * {
  color: var(--kg-dashboard-text);
}

@media (max-width: 920px) {
  html[data-kg-dashboard-visual="tutor-desk"] .ds-shell-layout.platform-shell-layout {
    grid-template-columns: minmax(0, 1fr) !important;
    min-height: 100svh;
  }

  html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__nav-items {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));
  }

  html[data-kg-dashboard-visual="tutor-desk"] .platform-shell-layout__logout-shell {
    margin-top: 0;
  }

  html[data-kg-dashboard-visual="tutor-desk"] :is(
    .ds-search-action-toolbar,
    .ds-filter-bar,
    .kgc-toolbar,
    .kg-email-toolbar,
    .kg-companies-toolbar,
    .kg-kpi-toolbar,
    .kg-settings-nav
  ) {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
}
`.replaceAll(
  'html[data-kg-dashboard-visual="tutor-desk"]',
  `html[data-kg-dashboard-visual="tutor-desk"]:not([data-kg-ui-standard="${TUTOR_DESK_SAAS_FINAL_UI_STANDARD}"])`
).trim();

function normalize(value = '') {
  return String(value || '').trim().toLowerCase();
}

function resolveDocument(doc) {
  if (doc && doc.documentElement) return doc;
  return typeof document !== 'undefined' ? document : null;
}

function shouldActivate({ appId = '', appScope = '', packId = '' } = {}) {
  const normalizedAppId = normalize(appId);
  const normalizedScope = normalize(appScope);
  const normalizedPackId = normalize(packId);
  return normalizedPackId === TUTOR_DESK_PACK_ID
    && (normalizedAppId === DASHBOARD_APP_ID || normalizedScope === DASHBOARD_APP_SCOPE);
}

function setDashboardVisualState(doc, active) {
  if (!doc?.documentElement) return;
  if (active) {
    doc.documentElement.setAttribute('data-kg-dashboard-visual', TUTOR_DESK_PACK_ID);
    doc.documentElement.setAttribute('data-kg-dashboard-visual-app', DASHBOARD_APP_ID);
    return;
  }
  doc.documentElement.removeAttribute('data-kg-dashboard-visual');
  doc.documentElement.removeAttribute('data-kg-dashboard-visual-app');
}

function hasTutorDeskSaasFinalUiProfile(doc) {
  return doc?.documentElement?.getAttribute?.('data-kg-ui-standard') === TUTOR_DESK_SAAS_FINAL_UI_STANDARD;
}

function ensureStyleElement(doc) {
  if (!doc?.head || doc.getElementById(STYLE_ID)) return;
  const style = doc.createElement('style');
  style.id = STYLE_ID;
  style.textContent = DASHBOARD_TUTOR_VISUAL_STYLES;
  doc.head.appendChild(style);
}

export function ensureDashboardTutorVisualParity({
  appId = '',
  appScope = '',
  appearanceId = '',
  packId = '',
  doc = resolveDocument()
} = {}) {
  const targetDocument = resolveDocument(doc);
  if (!targetDocument) return false;
  const active = !hasTutorDeskSaasFinalUiProfile(targetDocument)
    && shouldActivate({ appId, appScope, packId });
  if (!active) {
    setDashboardVisualState(targetDocument, false);
    return false;
  }

  ensureStyleElement(targetDocument);
  setDashboardVisualState(targetDocument, true);

  if (typeof window !== 'undefined' && !window.__KG_DASHBOARD_TUTOR_VISUAL_LISTENER__) {
    window.__KG_DASHBOARD_TUTOR_VISUAL_LISTENER__ = true;
    window.addEventListener('kg:appearance-theme-changed', (event) => {
      const detail = event?.detail || {};
      const nextActive = !hasTutorDeskSaasFinalUiProfile(targetDocument) && shouldActivate({
        appId: DASHBOARD_APP_ID,
        appScope: detail.appScope,
        packId: detail.appearancePackId || detail.packId
      });
      setDashboardVisualState(targetDocument, nextActive);
    });
  }

  if (normalize(appearanceId) && normalize(appearanceId) !== 'figma') {
    return false;
  }
  return true;
}
